<template>
  <div class="space-ba-xxl" id="mitglieder">

    <!-- <h2 class="space-ba-xs">Mitglieder</h2> -->

    <!-- VORSTAND -->
    <div class="space-ba-m">
      <!-- EINLEITUNG VORSTAND -->
      <div class="space-ba-s" v-html="newLineText(entries.einleitungVorstand)"></div>

      <!-- VORSTAND -->
      <div v-for="(item, i) in entries.vorstand" :key="i">
        <!-- ZWISCHENTITEL -->
        <div v-if="item.__typename === 'vorstand_zwischentitel_BlockType'">
          <p>{{item.zwischentitel}}</p>
        </div>
        <!-- PERSONEN TEXTFELD -->
        <div class="space-ba-xs" v-if="item.__typename === 'vorstand_person_BlockType'">
          <div class="type-l" v-html="newLineText(item.person)"></div>
          <div class="type-l" v-html="newLineText(item.institution)"></div>
        </div>
        <!-- PERSONEN TEAM LINK -->
        <div class="space-ba-xs" v-if="item.__typename === 'vorstand_teamMemberMitLink_BlockType'">
          <div class="type-l">
            <router-link class="link-arrow-a type-l" :to="'/team/' + item.teamMemberMitLink[0].slug">
              {{item.teamMemberMitLink[0].title}}
            </router-link>
            <svg class="link-arrow-icon" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-575.000000, -3298.000000)" fill="#20377A" fill-rule="nonzero">
                  <polygon points="577.3 3319.404 593.572 3303.168 593.572 3314.4 596.164 3314.4 596.164 3298.632 580.396 3298.632 580.396 3301.224 591.592 3301.224 575.356 3317.496"></polygon>
                </g>
              </g>
            </svg>
          </div>
          <div class="type-l" v-html="newLineText(item.teamMemberMitLink[0].institution)"></div>
        </div>
      </div>
    </div>


    <!-- EINLEITUNG MITGLIEDER -->
    <div class="space-ba-s" v-html="newLineText(entries.einleitungMitglieder)"></div>
    <div v-for="(item, i) in entries.mitglieder" :key="i">
      <!-- PERSONEN TEXTFELD -->
      <div class="space-ba-xs" v-if="item.__typename === 'mitglieder_person_BlockType'">
        <div class="type-l" v-html="newLineText(item.person)"></div>
        <div class="type-l" v-html="newLineText(item.institution)"></div>
      </div>
      <!-- PERSONEN TEAM LINK -->
      <div class="space-ba-xs" v-if="item.__typename === 'mitglieder_teamMemberMitLink_BlockType'">
        <div class="type-l">
          <router-link class="link-arrow-a type-l" :to="'/team/' + item.teamMemberMitLink[0].slug">
            {{item.teamMemberMitLink[0].title}}
          </router-link>
          <svg class="link-arrow-icon" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-575.000000, -3298.000000)" fill="#20377A" fill-rule="nonzero">
                <polygon points="577.3 3319.404 593.572 3303.168 593.572 3314.4 596.164 3314.4 596.164 3298.632 580.396 3298.632 580.396 3301.224 591.592 3301.224 575.356 3317.496"></polygon>
              </g>
            </g>
          </svg>
        </div>
        <div class="type-l" v-html="newLineText(item.teamMemberMitLink[0].institution)"></div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "Mitglieder",
  props: {
    entries: Object,
  },
  data() {
    return {};
  },
  methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 .link-arrow-wrapper {
  display: flex;
  align-items: center;
  & a, & svg {
    display: block;
  }
}
</style>


